module.exports = __webpack_public_path__ + "img/item11.60a69914.png";